import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "../styles/Month.css";
import { useNavigate } from "react-router-dom";

const Month = () => {
  const [monthlyRatings, setMonthlyRatings] = useState({});
  const [selectedYear, setSelectedYear] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReviews = async () => {
      const querySnapshot = await getDocs(collection(db, "hotelReviews"));
      const reviewList = querySnapshot.docs.map((doc) => doc.data());

      const monthGroups = {};

      reviewList.forEach((review) => {
        const date = review.createdAt?.toDate
          ? review.createdAt.toDate()
          : new Date(review.createdAt);

        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

        if (!monthGroups[monthKey]) {
          monthGroups[monthKey] = [];
        }

        monthGroups[monthKey].push(review.overall || 0);
      });

      const averages = {};

      for (const month in monthGroups) {
        const ratings = monthGroups[month];
        const average = ratings.reduce((a, b) => a + b, 0) / ratings.length;
        averages[month] = average.toFixed(2);
      }

      setMonthlyRatings(averages);
    };

    fetchReviews();
  }, []);

  const getYears = () => {
    const years = new Set(Object.keys(monthlyRatings).map((key) => key.split("-")[0]));
    return Array.from(years).sort().reverse();
  };

  const calculateYearlyAverages = () => {
    const yearGroups = {};

    for (const month in monthlyRatings) {
      const year = month.split("-")[0];
      if (!yearGroups[year]) yearGroups[year] = [];
      yearGroups[year].push(parseFloat(monthlyRatings[month]));
    }

    const yearlyAverages = {};
    for (const year in yearGroups) {
      const avg = yearGroups[year].reduce((a, b) => a + b, 0) / yearGroups[year].length;
      yearlyAverages[year] = avg.toFixed(2);
    }

    return yearlyAverages;
  };

  const years = getYears();
  const yearlyAverages = calculateYearlyAverages();

  return (
    <div className="month-container">
        <button className="back-button" onClick={() => navigate("/admin")}>Back</button> 
      <h2>Monthly & Yearly Ratings Summary</h2>

      <div className="filter-bar">
        <label><strong>Select Year: </strong></label>
        <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
          <option value="">All</option>
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      {years
        .filter((year) => !selectedYear || year === selectedYear)
        .map((year) => (
          <div key={year} className="year-group">
            <h3>{year} - Yearly Average: ⭐ {yearlyAverages[year]}</h3>
            <div className="rating-list">
              {Object.keys(monthlyRatings)
                .filter((month) => month.startsWith(year))
                .sort()
                .map((month) => (
                  <div key={month} className="rating-card">
                    <strong>
                      {new Date(`${month}-01`).toLocaleString("default", {
                        month: "long",
                        year: "numeric",
                      })}
                    </strong>
                    <p>Average Overall Rating: ⭐ {monthlyRatings[month]}</p>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default Month;
